<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <div class="px-4">
        <date-interval name="Дата создания" :valueFrom.sync="filter.createdFrom" :valueTo.sync="filter.createdTo"/>
        <date-interval name="Дата изменения" :valueFrom.sync="filter.updatedFrom" :valueTo.sync="filter.updatedTo"/>
        <user-autocomplete-multiple name="Клиенты" :select.sync="filter.usersSelected" selectAllEnabled/>
        <text-field name="Название" :value.sync="filter.name"/>
        <text-field name="Номер заявки" :value.sync="filter.sid"/>
        <v-select
            label="Статус"
            v-model="filter.status"
            :items="[{name:'Не выбрано',value:null},{name:'Создано',value:'create'},{name:'Успешно',value:'success'},{name:'Отказано',value:'error'}]"
            outlined dense hide-details="auto" class="mb-3" item-text="name"
        />
        <text-field name="Комментарий лаборатории" :value.sync="filter.message"/>
        <checkbox-field name="Клиент не найден" class="mb-3" :value.sync="filter.userClientNotFound"/>
      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
          ref="table"
          name="Список"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="[
            { text: 'ID', value: 'id', class:'text-no-wrap'},
            { text: 'Лаборатория', value: 'userAuthor.firstName', class:'text-no-wrap'},
            { text: 'Номер заявки', value: 'sid', class:'text-no-wrap'},
            { text: 'Клиент', value: 'userClient.lastName', class:'text-no-wrap'},
            { text: 'Название', value: 'name', class:'text-no-wrap'},
            { text: 'Файлы', value: 'text', class:'text-no-wrap'},
            { text: 'Статус', value: 'created',  class:'text-no-wrap'},
            { text: 'Создано', value: 'created',  class:'text-no-wrap'},
            { text: 'Изменено', value: 'updated',  class:'text-no-wrap'},
          ]"
          class="table5"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-no-wrap">{{item.id}}</td>
            <td class="text-no-wrap">
              <lazy :data="item.userAuthor.firstName">
                {{item.userAuthor.firstName}}
              </lazy>
            </td>
            <td class="text-no-wrap">
              {{item.sid}}
              <copy-button :data="item.sid"/>
            </td>
            <td class="text-no-wrap">
              <div v-if="$tools.isEmpty(item.userClientFirstName)">
                <lazy :data="item.userClient.firstName">
                  <user-full-name :user="item.userClient" short/>
                </lazy>
              </div>
              <tooltip-view v-else>
                <template v-slot:action>
                  Не найден<v-icon small class="ml-2">mdi-information-outline</v-icon>
                </template>
                <template v-slot:content>
                  <div class="caption pb-2">
                    <div>{{item.userClientLastName}} {{item.userClientFirstName}}</div>
                    <div>{{$tools.dateTimeFormat(item.userClientBirth, 'DD.MM.YYYY')}}</div>
                  </div>
                </template>
              </tooltip-view>
            </td>
            <td class="text-no-wrap">
              <big-text width="360" height="32" :text="item.name"/>
            </td>
            <td class="text-wrap">
              <lazy :data="item.medias">
                <v-btn
                    v-for="(v,k) in item.medias" :key="k"
                    @click="mediaId=v.id"
                    class="mr-2"
                    depressed small
                >
                  Документ
                </v-btn>
              </lazy>
            </td>
            <td class="text-no-wrap">
              <span v-if="item.status==='create'">Создана</span>
              <span v-if="item.status==='success'">
                <v-avatar color="success" size="16" style="margin-top:-2px" class="mr-1"><v-icon color="white" size="12">mdi-check</v-icon></v-avatar>
                Успешно
              </span>
              <span v-if="item.status==='error'">
                <v-avatar color="error" size="16" style="margin-top:-2px" class="mr-1"><v-icon color="white" size="12">mdi-close</v-icon></v-avatar>
                Отказано
              </span>
              <tooltip v-if="!$tools.isEmpty(item.message)" bottom>
                <template v-slot:default><v-icon small class="ml-2">mdi-comment-text-outline</v-icon></template>
                <template v-slot:content>
                  {{item.message}}
                </template>
              </tooltip>
            </td>
            <td class="text-no-wrap">{{$tools.dateTime(item.created)}}</td>
            <td class="text-no-wrap">{{$tools.dateTime(item.updated)}}</td>
          </tr>
        </template>
      </n-table-view>

      <media-view
          :media-id.sync="mediaId"
          @updateList="$refs.table.load()"
      />
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import LayoutView from "@/components/LayoutView";
import {Entity_LabRequest, Entity_Media, Entity_User} from "../../../EntityStoreCacheService";
import NTableView from "@/componentsV2/base/NTableView.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import MediaView from "@/views/Media/MediaView.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import moment from "moment/moment";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import CopyButton from "@/components/CopyButton.vue";
import Lazy from "@/componentsV2/base/Lazy.vue";
import TooltipView from "@/components/TooltipView.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import BigText from "@/componentsV2/custom/BigText.vue";

export default {
  components: {
    BigText,
    CheckboxField,
    TooltipView,
    Lazy,
    CopyButton,
    TextField,
    UserAutocompleteMultiple,
    DateInterval,
    UserFullName,
    MediaView,
    Tooltip,
    NTableView,
    LayoutView,
  },
  data:()=>({
    state: new State(),
    mediaId:null,
    filter: {
      createdFrom: moment(new Date()).format('DD.MM.YYYY'),
      createdTo: moment(new Date()).format('DD.MM.YYYY'),
      updatedFrom: null,
      updatedTo: null,
      usersSelected: [],
      name: null,
      sid: null,
      message: null,
      status: null,
      userClientNotFound: false,
    },
  }),
  watch:{
    filter: {
      handler() {
        this.$refs.table.load();
      },
      deep: true,
    },
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_LabRequest()
          .selects(Entity_LabRequest.id)
          .selects(Entity_LabRequest.sid)
          .selects(Entity_LabRequest.name)
          .selects(Entity_LabRequest.status)
          .selects(Entity_LabRequest.message)
          .selects(Entity_LabRequest.created)
          .selects(Entity_LabRequest.updated)
          .selects([Entity_LabRequest.userAuthor, Entity_User.id].join('.'))
          //.selects([Entity_LabRequest.userAuthor, Entity_User.firstName].join('.'))
          .selects([Entity_LabRequest.userClient, Entity_User.id].join('.'))
          .selects(Entity_LabRequest.userClientFirstName)
          .selects(Entity_LabRequest.userClientLastName)
          .selects(Entity_LabRequest.userClientBirth)
          //.selects([Entity_LabRequest.userClient, Entity_User.firstName].join('.'))
          //.selects([Entity_LabRequest.userClient, Entity_User.lastName].join('.'))
          //.selects([Entity_LabRequest.userClient, Entity_User.secondName].join('.'))
          //.selects([Entity_LabRequest.medias, Entity_Media.id].join('.'))
          .page(page)
          .onPage(onPage);

      sortFields.forEach(v=>{
        rb.order(v.field, v.isAsc)
      });

      if(this.filter.createdFrom)
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.created].join('.')+'>=?',moment(this.filter.createdFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
      if(this.filter.createdTo)
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.created].join('.')+'<=?',moment(this.filter.createdTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
      if(this.filter.updatedFrom)
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.updated].join('.')+'>=?',moment(this.filter.updatedFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
      if(this.filter.updatedTo)
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.updated].join('.')+'<=?',moment(this.filter.updatedTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
      if (this.filter.usersSelected.length>0)
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.userClient, Entity_User.id].join('.')+' in (?)',this.filter.usersSelected.map(i=>i.id))
      if(!this.$tools.isEmpty(this.filter.name))
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.name].join('.')+' LIKE ?','%'+this.filter.name+'%');
      if(!this.$tools.isEmpty(this.filter.sid))
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.sid].join('.')+' = ?',this.filter.sid);
      if(!this.$tools.isEmpty(this.filter.message))
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.message].join('.')+' LIKE ?','%'+this.filter.message+'%');
      if(!this.$tools.isEmpty(this.filter.status))
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.status].join('.')+' = ?',this.filter.status);
      if(this.filter.userClientNotFound)
        rb.filterAnd([Entity_LabRequest.entity, Entity_LabRequest.userClient].join('.')+' IS NULL');

      rb.addStateCallback(s=>{
        if(s.success){
          if(s.items.length===0)
            return;

          let ids = [];
          let userIds = [];
          s.items.forEach(v => {
            ids.push(v.id);
            userIds.push(v.userAuthor.id);
            if(!this.$tools.isEmpty(v.userClient))
              userIds.push(v.userClient.id);
          })
          userIds = [...new Set(userIds)];

          new Entity_User()
              .selects(Entity_User.firstName)
              .selects(Entity_User.lastName)
              .selects(Entity_User.secondName)
              .filterAnd([Entity_User.entity, Entity_User.id].join('.') + ' in (?)', userIds)
              .addStateCallback(s1 => {
                if (s1.success) {
                  s.items.forEach(v => {
                    v.userAuthor = s1.items.filter(v1 => v1.id === v.userAuthor.id)[0]
                    const f = s1.items.filter(v1 => v1.id === v.userClient?.id);
                    if(f.length>0) v.userClient = f[0];
                    v._key = this.$tools.key(v);
                  })
                }
              })
              .page(1)
              .onPage(onPage)
              .request();

          new Entity_Media()
              .selects(Entity_Media.id)
              .selects([Entity_Media.labRequest, Entity_LabRequest.id].join('.'))
              .filterAnd([Entity_Media.entity, Entity_Media.labRequest, Entity_LabRequest.id].join('.') + ' in (?)', ids)
              .page(1)
              .onPage(onPage)
              .addStateCallback(s1 => {
                if (s1.success) {
                  s.items.forEach(v => {
                    v.medias = s1.items.filter(v1 => v1.labRequest.id === v.id)
                    v._key = this.$tools.key(v);
                  })
                }
              })
              .request();
        }
      });


      return rb;
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-btns {
    display: flex;
    gap: 10px;
  }
</style>